module.exports = __webpack_public_path__ + "img/dotBlack.6ce857a4.svg";